<template>
    <!-- // plat--0:云端  1：本地镜像 -->
    <div class="Login_wrapper" :style="{backgroundImage: 'url('+require('@/assets/images/themes/'+customSet.loginBgName+'.jpg')+')'}">
        <div class="login-box">
            <h3 class="login-title" style="color: #00a1ff;font-size: 42px;padding-bottom: 30px;">田田阅读</h3>
            <!-- <h3 class="login-title">
                <img src="../../assets/images/loginlogo.png" v-if="orgId!='3883'" />
                <span style="color:#409EFF;font-size:32px;" v-else>{{ orgName }}</span>
            </h3> -->
            <!-- <div class="login-way" v-if="!isDirectLog">
                <span :class="{'active': activeWay==0}" @click="handleChange(0)">普通登录</span>
                <span :class="{'active': activeWay==1}" @click="handleChange(1)">手机号登录</span>
            </div> -->
            <el-form ref="loginForm" :model="loginform" :rules="rules" class="">  
                <el-form-item prop="deptId">
                    <el-select v-if="!isOrgArg" @change="getOrgInfoById" style="width:100%" v-model="loginform.deptId" filterable remote reserve-keyword placeholder="机构/图书馆" :filter-method='getOrgListByKeys'>
                        <template slot="prefix">
                            <span style="padding: 5px;font-size: 18px; color: #C0C4CC;">
                                <i class="el-icon-school"></i>
                            </span>
                        </template>
                        <el-option v-for="item in orgList" :key="item.pkid" :label="item.orgName" :value="item.pkid"></el-option>                    
                    </el-select>
                    <div v-else>
                        机构：{{ orgName }}
                    </div>
                </el-form-item>
                <div v-if="!isDirectLog">
                    <!-- 登录方式 -->
                    <el-radio-group v-model="activeWay" @change="handleChange" style="padding:0px 0px 20px;" v-if="wayType.indexOf('3') > -1">
                        <el-radio :label="item.label" v-for="(item, index) in loginTypeArr" :key="index">{{ item.text }}</el-radio>
                    </el-radio-group>
                    <el-form-item v-if="activeWay==0" prop="userName">
                        <el-input type="text" prefix-icon="el-icon-user" placeholder="账号" v-model="loginform.userName" />
                    </el-form-item>
                    <el-form-item v-if="activeWay==0" prop="userPwd">
                        <el-input type="userPwd" prefix-icon="el-icon-lock" placeholder="密码" v-model="loginform.userPwd" show-password @keyup.enter.native="loginSubmit" />
                    </el-form-item>
                    <el-form-item v-if="activeWay==1" prop="phone">
                        <el-input type="text" prefix-icon="el-icon-mobile-phone" placeholder="手机号" v-model="loginform.phone" />
                    </el-form-item>
                    <el-form-item v-if="activeWay==1" prop="smsCode">
                        <el-input class="input-code" type="text" prefix-icon="el-icon-chat-dot-round" placeholder="验证码" v-model="loginform.smsCode" @keyup.enter.native="phoneSubmit" />
                        <el-button :class="{'getcode': true, 'disabled': (!isPhone || countdown>0)}" :loading="isSend" @click="sendToPhone">{{ countdown > 0 ? countdown + 's后重新获取' : '获取验证码'  }}</el-button>
                        <!-- <p class="sendSuccess" v-if="hasGetcode"><i class="el-icon-circle-check"></i>验证码已发送至你的手机，请查收！</p> -->
                    </el-form-item>
                </div>                
            </el-form>
            <div class="login-fun">
                <!-- <div class="remind">
                    <el-checkbox v-model="isChecked">30天内记住我</el-checkbox>
                </div> -->
                <div v-if="!isDirectLog">
                    <el-button type="primary" class="login-btn" :style="!hasOrg ? 'width:100%;' : 'width:310px;'" :loading="logining" @click="loginSubmit()" v-if="activeWay==0">{{ logining ? '登录中...':'登录' }}</el-button>
                    <el-button type="primary" class="login-btn" :style="!hasOrg ? 'width:100%;' : 'width:310px;'" :loading="logining" @click="phoneSubmit()" v-if="activeWay==1">{{ logining ? '登录中...':'手机号登录' }}</el-button>
                    <span v-if="hasOrg" style="display:inline-block;color:#00a1ff;width:80px;cursor: pointer;" @click="switchOrgHandel">
                        <i class="el-icon-sort" style="transform: rotate(90deg);"></i>
                        {{ !isOrgArg ? '返回' : '切换机构' }}
                    </span>
                </div>
                <div style="text-align:center;" v-else>
                    <el-button type="primary" class="login-btn" style="width:100%;" :loading="logining" @click="directLoginByOrg()">{{ logining ? '一键登录中...':'一键登录' }}</el-button>
                    <!-- <span class="directBtn">{{ logining ? '一键登录中...':'一键登录' }}</span> -->
                    <span style="display:inline-block;margin:15px auto;color:#00a1ff;cursor: pointer;" @click="isDirectLog=!isDirectLog">
                        <i class="el-icon-sort" style="transform: rotate(90deg);"></i>
                        切换账号密码登录
                    </span>
                </div>
                <div class="other">
                    <span style="color:#999;" v-if="wayType.indexOf('2') > -1 || wayType.indexOf('4') > -1">其它登录方式:</span>
                    <a v-if="wayType.indexOf('4') > -1" href="https://sp-tiantianyuedu.carsi.edu.cn/api/authorize?response_type=code&client_id=tiantianyuedu&state=tiantianyuedu" class="carsi_logo">CARSI</a>
                    <a class="wxLogin" @click="getWXcode" v-if="wayType.indexOf('2') > -1">微信扫一扫</a>
                    <a class="direct" v-if="!isDirectLog&&(autoLoginSwitcher == 2 || autoLoginSwitcher == 3)" @click="isDirectLog=!isDirectLog"><i class="el-icon-sort" style="transform: rotate(90deg);"></i>一键登录</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { plat, orgCustoms} from '../../dataJson/custom.js'
import {  loginInfo, login, checkCode, readerAutoLogin, getLoginOrgInfo, sendCode, phoneLogin, orgInfoByid  } from "@/api/login"
import {  generator } from "@/api/colinfo"
import { byid } from "@/api/ebook";//处理图片
import { getItem, setItem, getUserInfo } from "@/common/utils/localStorage.js";
import MD5 from "../../common/utils/MD.js"
import { infoLogin, autoLogin, orgLoginType, setConfig } from "@/api/user";
import popup from "../../common/plugin/dialog/index";
import wxLogin from './wxCodeLogin.vue'
import { addId } from '../../api/visitlog.js';

export default {
    inject:['reload'],
    name: "Login",
    data() {
        let vm = this;
        return {
            customSet: orgCustoms[plat],
            wayType: [], //1-账号密码，2-微信扫码，3-手机验证码，4-CARSI授权
            // hasGetcode: false,
            activeWay: 0,
            loginType: 1,
            loginTypeArr: [
                {label:0,text:'账号登录'},
                {label:1,text:'手机号登录'},
            ],
            orgId:'5826',
            orgName:'锦州医科大学图书馆',
            isPhone: false,
            isSend: false,
            countdown: 0,
            timer: null,
            isOrgArg: false, //是否含有机构参数
            hasOrg: false,//是否显示切换机构
            userInfo: getUserInfo(),
            logining: false,
            loginform: {
                // deptId: '3590',
                // userName: 'qdhxkjxydz', //青岛恒星科技学院图书馆
                // userPwd: '123456',
                // deptId: '',
                // userName: '',
                // userPwd: '',
                // deptId: '3431',
                // userName: 'nczydx',//南昌职业大学图书馆
                // userPwd: '123456',
                // phone: '',
                // smsCode:''
                deptId: '5826',
                userName: 'jzykdx001',//锦州医科大学图书馆
                userPwd: '123456',
                // deptId: '',
                // userName: '',//天津渤海职业学院
                // userPwd: '',
                phone: '',
                smsCode:''
            },
            isChecked: true,//30天记住密码
            // 表单验证，需要在 el-form-item 元素中增加 prop 属性
            rules: {
                deptId: [
                    {required: true,message: "请选择机构/图书馆！",trigger: "change"}
                ],
                userName: [
                    {required: true,message: "账号不可为空！",trigger: "blur"}
                ],
                userPwd: [
                    {required: true, message: "密码不可为空！",trigger: "blur"}
                ],
                phone: [
                    {required: true, message: "手机号不可为空！",trigger: "blur"},
                    {
                        validator(rule, value, callback) {
                            var nameRe = new RegExp(/^1[3456789]\d{9}$/);
                            // vm.hasGetcode = false;
                            if (!nameRe.test(value)) {
                                vm.isPhone = false;
                                callback(new Error('请输入正确的手机号！'));
                            } else {
                                vm.isPhone = true;
                                callback();
                            }
                        }, trigger: 'blur'
                    }
                ],
                smsCode: [
                    {required: true, message: "验证码不可为空！",trigger: "blur"}
                ],
            },
            logining: false,
            orgList: [],
            // orgId: '',
            isDirectLog: false,//选择机构后，能否一键登录
            autoLoginSwitcher: '',//:自动登录开关，1-正常登录(需要账号和密码登录)，2-IP段自动登陆，3-机构无条件自动登录
            // autoLoginSignal: "", //是否自动登录账号，1-是，2-否
            elLoading: null,
        };
    },
    created() {
        let vm = this;
        // vm.toValidity();
        // if(plat != 0){
        //     vm.AutoLoginByOrg(); //ip自动登录
        // }
    },
    mounted() {
        let vm = this;
        if(Object.keys(vm.userInfo).length === 0){  //是否含有本地用户登录信息
            if(vm.customSet.index == 0){
                let dircode = vm.$route.params.dircode;
                if(dircode) {
                    vm.getParamOrgId(dircode);
                }else{
                    if(getItem('dircode')){
                        vm.getParamOrgId(getItem('dircode'));
                    }
                }
            }else{
                vm.isOrgArg = true;
                vm.loginform.deptId = vm.customSet.orgId;//机构
                vm.orgName = vm.customSet.orgName;
                vm.loginSubmit(); //免登陆
                // vm.getOrgInfoById(vm.loginform.deptId); //根据机构判断登录方式
            }
        }else{
            if(getItem('remindLink')){
                if(getItem('remindLink') == '#/'){
                    vm.$router.push({name:"HomePage"});
                }else{
                    window.location.assign(getItem('remindLink'));
                }
            } else{
                vm.$router.push({name:"HomePage"});
            }
        }
    },
    methods: {
        //切换机构
        switchOrgHandel(){
            let vm = this;
            if(!vm.isOrgArg){
                vm.isOrgArg = true;
                vm.loginform.deptId = vm.orgId;
            }else{
                vm.isOrgArg = false;
                vm.loginform.deptId = '';
            }
        },
        //根据orgid查询机构信息
        getOrgInfoById(orgId){
            let vm = this;
            orgInfoByid({
                pkid: orgId,
                visitType: 2,
                visitUrl: location.href,
                visitFunc: "",
            }).then(res => {
                if(res.status){
                    // vm.orgName = res.data.orgName;
                    // vm.orgId = res.data.pkid;
                    // vm.loginform.deptId = res.data.pkid;
                    // vm.hasOrg = true;//显示切换
                    // vm.isOrgArg = true;
                    // vm.wayType = res.data.loginType.split(',');
                    res.data.loginType==null ? vm.wayType = [] : vm.wayType = res.data.loginType.split(',');
                    vm.autoLoginSwitcher = res.data.autoLoginSwitcher;
                    // autoLoginSwitcher:自动登录开关，1-正常登录(需要账号和密码登录)，2-IP段自动登陆，3-机构无条件自动登录
                    //autoLoginSwitcher除了2、3 需要一键登录，其余情况都是需要账号、密码登录
                    if(res.data.autoLoginSwitcher == 2 || res.data.autoLoginSwitcher == 3){
                        vm.isDirectLog = true; //显示一键登录
                    }else{
                        vm.isDirectLog = false;
                    }
                    //判断当前IP段是否可以一键登录
                    // vm.getCurIPisLogin(res.data.pkid);
                }
            }).catch(err => {

            });
        },
        //获取权限显示
        getSetConfig(){
            let vm = this,
                obj = {
                    // orgId: getUserInfo().orgId,
                    visitType: 2,
                    visitUrl: location.href,
                    visitFunc: "",
                };
            setConfig(obj).then(res => {
                if(res.status){
                    // t.config = res.data;
                    let configData = [],
                        list = {};
                    for(var i = 1;i<=40;i++){
                        let list = {type:i, orgId:getUserInfo().orgId, dataStatus:1, enableStatus: 2}; //默认不显示
                        res.data.map((item, index) =>{
                            if(item.type == i){
                                // list.pkid = item.pkid;
                                list.enableStatus = item.enableStatus;
                                return true;
                            }
                        });
                        configData.push(list);
                    }
                    // t.config = configData;
                    setItem('config', JSON.stringify(configData));
                    vm.$message({
                        message: "登录成功！",
                        type: "success"
                    });
                    if(vm.orgId == '3883' && getItem('pkid')){
                        let params = {
                            orgId: getUserInfo().orgId,
                            source: getItem('source'),
                            pkid: getItem('pkid'),
                            visitType: 2,
                            visitUrl: location.href,
                            visitFunc: "",
                        };
                        byid(params).then(res => {
                            let fileTypes = res.data.fileTypes,
                                type = '';
                            if(fileTypes.split(',').lenght > 2){ //如果返回2种阅读方式0、1，那就优先跳转EPUB
                                type = 1;
                            }else if(fileTypes=='0'){//PDF
                                type = 0;
                            }else if(fileTypes=='1'){//EPUB
                                type = 1;
                            }
                            if(getItem('source') == 1){ //平台的书
                                let IP = orgCustoms[plat].IP,
                                    URL = '?loadType=1&ebookId=' + res.data.pkid + '&authKey=' + localStorage.authKey;
                                // 1：epub格式；0：pdf格式
                                if(type == '0'){
                                    URL = '/pdfindex.html' + URL;
                                }
                                window.location.href = IP + URL;
                            }else{
                                window.location.href = res.data.readUrl;
                            }
                            removeItem('remindLink');
                        }).catch(err => {
                        });
                    }else{
                        if(getItem('remindLink') != null) {
                            vm.$router.push({ path: getItem('remindLink') });
                            removeItem('remindLink');
                            removeItem('dircode');
                        } else {
                            vm.$router.push({name:"HomePage"})
                        }
                    }
                }
            }).catch(err => {

            });
        },
        //判断当前IP段是否可以一键登录
        // getCurIPisLogin(val){
        //     let vm = this,
        //         obj={
        //             visitType: 2,
        //             visitUrl: location.href,
        //             visitFunc: "",
        //         };
        //      infoLogin(obj).then(res => {
        //         if(res.status){
        //             if(val == res.data.orgId){
        //                 //autoLoginSwitcher:自动登录开关，1-正常登录(需要账号和密码登录)，2-IP段自动登陆，3-机构无条件自动登录
        //                 if(res.data.autoLoginSwitcher == 1){
        //                     vm.isDirectLog = false;
        //                 }else{
        //                     vm.isDirectLog = true; //显示一键登录
        //                     vm.loginform.deptId = val;
        //                     vm.autoLoginSwitcher = res.data.autoLoginSwitcher;
        //                 }
        //             }else{
        //                 vm.isDirectLog = false;
        //             }
        //         }                
        //     });
        // },
        //选择机构自动登录
        // changeOrgHandle(val) {//val：选择机构的orgId
        //     let vm = this,
        //         obj = {
        //             "visitType": 2,
        //             "visitUrl": location.href,
        //             "visitFunc": "",
        //         };
        //     vm.activeWay = 0;
        //     orgLoginType({
        //         orgId: val,
        //         visitType: 2,
        //         visitUrl: location.href,
        //         visitFunc: '',
        //     }).then(res => {
        //         if(res.status){
        //             // vm.orgName = res.data.orgName;
        //             // vm.loginform.deptId = res.data.pkid;
        //             // vm.hasOrg = true;//显示切换
        //             // vm.isOrgArg = true;
        //             // vm.wayType = res.data.loginType.split(',');
        //             // vm.wayType = [1,2,3,4]; //1-账号密码，2-微信扫码，3-手机验证码，4-CARSI授权
        //             vm.wayType = [];
        //             res.data.forEach((ele, index) => {
        //                 vm.wayType.push(ele.loginType);
        //             });
        //             vm.getOrgInfoById(val);
        //             //判断当前IP段是否可以一键登录
        //             // vm.getCurIPisLogin(val);
        //         }
        //     }).catch(err => {

        //     }); 
        // },
        //切换登录方式
        handleChange(val){
            let vm = this;
            vm.activeWay = val;
            val==0 ? vm.loginType = 1 : vm.loginType = 2;
            vm.autoLoginSwitcher = ''; //清空
            vm.$refs.loginForm.clearValidate(['userName', 'userPwd', 'phone', 'smsCode']); //清除校验
        },
        //发送校验码
        sendToPhone(){
            let vm = this;
            if(vm.isPhone && vm.countdown == 0){                
                vm.$refs.loginForm.validateField('deptId', valid=>{
                    if(!valid){ //通过
                        vm.isSend = true;
                        if(vm.countdown == 0){
                            sendCode({
                                loginType: 3,
                                orgId: vm.loginform.deptId,
                                phone: vm.loginform.phone
                            }).then(res => {
                                if(res.status){
                                    // console.log('发送成功！');
                                    vm.$message({
                                        message: '验证码已发送成功！',
                                        type: 'success'
                                    });               
                                    vm.isSend = false;
                                    vm.countdown = 60;
                                    vm.timer = setInterval(() => {
                                        // vm.hasGetcode = true; //提示已发送
                                        vm.countdown--;
                                        if (vm.countdown == 0) {
                                            clearInterval(vm.timer);
                                        }
                                    }, 1000);
                                }else{
                                    vm.$message({
                                        message: res.errorMsg || '发送失败！',
                                        type: 'error'
                                    });
                                }
                            }).catch(err => {

                            });
                        }
                    }else{ //不通过
                    }
                });
            }
        },
        //根据登录传参自动登录
        // autoLoginByOrgId(orgId, orgName){
        //     let vm = this,
        //         formData = {orgId: orgId, autoLoginSwitcher: 3};
        //     readerAutoLogin(formData).then(res => {
        // 		if(res && res.code==200){
        //             vm.logining = true;
        //             setItem("token", res.data.token);
        //             setItem("orgId", res.data.orgId);
        //             setItem("userId", res.data.pkid);
        //             setItem("userInfo", res.data);
        //             setItem("authKey", res.data.loginRedisKey);
        //             setItem("demoSignal", res.data.demoSignal);
        //             setItem("account", res.data.account);                        
        //             // console.log(res.data.orgId + "|#|" + res.data.pkid + "|#|" + res.data.token);
        //             let authKey = MD5(res.data.orgId + "|#|" + res.data.pkid + "|#|" + res.data.token);
        //             let obj = {
        //                 "authKey": authKey,
        //                 "visitType": 2,
        //                 "visitUrl": location.href,
        //                 "visitFunc": "",
        //             };
        //             generator(obj).then(res2 => {
        //                 setItem("sign", res2.data);
        //                 if(res2.code == "") {
        //                     vm.$router.push({name:"Login"});
        //                 } else {
        //                     vm.$message({
        //                         "message": "登陆成功",
        //                         "type": "success"
        //                     });
        //                     if(getItem('remindLink') != null) {
        //                         vm.$router.push({ path: getItem('remindLink') })
        //                         removeItem('remindLink');
        //                     } else {
        //                         vm.$router.push({name:"HomePage"});
        //                     }
        //                 }
        //                 vm.logining = false;
        //             });
        //         }else{
        //             vm.hasOrg = true;//显示切换
        //             vm.isOrgArg = true;
        //             vm.orgId = orgId;
        //             vm.loginform.deptId = orgId;
        //             vm.changeOrgHandle(orgId);
        //         }
        //     }).catch(err => {  

        //     }); 
        // },
        //根据登录传参获取机构名称和机构id
        getParamOrgId(dircode){
            let vm = this;            
            vm.elLoading = this.$loading({
                text: "加载中...", // 设置 loading 文本为 "加载中"
                spinner: "el-icon-loading", // 使用 Element UI 提供的加载图标
                background: "rgba(0, 0, 0, 0.35)", // 设置 loading 遮罩层背景色为半透明黑色
                customClass:'loginLoading',
                // target: document.querySelector('.codebox'), // 将 loading 遮罩层挂载到页面 body 元素上
            });
            getLoginOrgInfo({dirCode: dircode}).then(res => {
                if(res.status){
                    //如果机构是“江汉区图书馆”，不要显示任何“田田阅读”字眼
                    if(res.data.pkid == '3883'){
                        document.title = '江汉区图书馆';
                        vm.hasOrg = false;
                        vm.activeWay = 1;
                        vm.loginTypeArr = [{label:1, text:'手机号登录'}];
                    }else{
                        vm.hasOrg = true;
                    }
                    vm.isOrgArg = true;
                    vm.orgName = res.data.orgName;
                    vm.orgId = res.data.pkid;
                    vm.loginform.deptId = res.data.pkid;
                    res.data.loginType==null ? vm.wayType = [] : vm.wayType = res.data.loginType.split(',');
                    vm.autoLoginSwitcher = res.data.autoLoginSwitcher;
                    // autoLoginSwitcher:自动登录开关，1-正常登录(需要账号和密码登录)，2-IP段自动登陆，3-机构无条件自动登录
                    //autoLoginSwitcher除了2、3 需要一键登录，其余情况都是需要账号、密码登录
                    if(res.data.autoLoginSwitcher == 2 || res.data.autoLoginSwitcher == 3){
                        vm.isDirectLog = true; //显示一键登录
                        if(res.data.isAutoLogin == 1){//自动登录
                            vm.directLoginByOrg();
                        }
                    }else{
                        vm.isDirectLog = false;
                    }
                    // if(Object.keys(res.data).length > 0 && res.data.orgName){
                    //     vm.autoLoginByOrgId(res.data.orgId, res.data.orgName);
                    // }else{
                    //     vm.hasOrg = false;
                    // }
                }
                vm.elLoading.close();
            }).catch(err => {
                vm.elLoading.close();
            });
        },
        // checkCode() {
        //     let vm = this
        //     let userInfo = getUserInfo();
        //     var obj = {
        //         token: localStorage.getItem('token'),
        //         "visitType": 2,
        //         "visitUrl": location.href,
        //         "visitFunc": "",
        //     };
        //     checkCode(obj).then((res) => {
        //         if(res.code == 200) {
        //             if(localStorage.getItem('href') != null) {
        //                 this.$router.push({ path: localStorage.getItem('href') })
        //                 localStorage.removeItem("href");
        //             } else {
        //                 this.$router.push('HomePage');
        //             }
        //         }
        //     });
        // },
        // toValidity() {
        //     let vm = this;
        //     let userInfo = getUserInfo();
        //     var obj = {
        //         "visitType": 2,
        //         "visitUrl": location.href,
        //         "visitFunc": "",
        //     };
        //     validity(obj).then((res) => {
        //         if(res){
        //             if(res.data != null && res.data.validityStatus == 2) {
        //                 this.$router.push({ name: "404" })
        //             } else {
        //                 vm.Info()
        //                 vm.AutoLoginByOrg()
        //                 let userInfo = getUserInfo();
        //                 if (localStorage.getItem('token') != null) {
        //                     vm.checkCode()
        //                 }
        //             }
        //         }else{
        //             console.log('789778777');
        //         }
        //     });
        // },
        //根据关键字获取机构列表
        getOrgListByKeys(query) {
            let vm = this,
            obj = {
                "orgStatus": 1,
                "deviceType": 1,
                "orgName": query,
                "orgType": 1,
                "visitType": 2,
                "visitUrl": location.href,
                "visitFunc": "",
            };
            loginInfo(obj).then((res) => {
                vm.orgList = res.data.list;
                vm.autoLoginSwitcher = '';//清空
            });
        },
        //处理登录后的数据
        setLoginInfo(res){
            let vm = this;
            setItem("token", res.data.token);
            setItem("orgId", res.data.orgId);
            setItem("userId", res.data.pkid);
            setItem("userInfo", res.data);
            setItem("authKey", res.data.loginRedisKey);
            setItem("demoSignal", res.data.demoSignal);
            setItem("account", res.data.account);          
            let userInfo = getUserInfo();
            let authKey = MD5(userInfo.orgId + "|#|" + userInfo.pkid + "|#|" + userInfo.token)
            let obj = {
                "authKey": authKey,
                "visitType": 2,
                "visitUrl": location.href,
                "visitFunc": "",
            };
            generator(obj).then((result) => {
                if(result.status) {
                    setItem("sign", result.data);          
                    vm.getSetConfig();                                  
                    //记录登录
                    addId({
                        logAccount: res.data.account,
                        creatorId: res.data.pkid,
                        deviceType:1,//访问设备，1、PC，2-移动H5页面，3-小程序
                        actionType:1,//访问类型，1-登录，2-检索，3-浏览，4-阅读
                        visitFunc: "",
                        visitType: 2,
                        visitUrl:location.href,
                        loginType: vm.loginType,//登录类型，1-账号密码，2-短信，3-微信二维码，4-carsi
                    }).then(res=>{
                        if(res.status){
                            // vm.$router.push({name:"Login"});
                            vm.$router.push({name:"HomePage"});//如果是免登录，跳转首页
                        }
                    }).catch(err=>{

                    });
                }
                vm.logining = false;
            }).catch(error => {
                vm.logining = false;
            });
        },
        // 普通登录
        loginSubmit() {
            let vm = this,
                validateFieldList = [];
            // vm.$refs.loginForm.validateField(['userName', 'userPwd'], async(valid) => {
            //     if (!valid) {
            //         validateFieldList.push(valid);
            //         //防止elementUI中validateField对多个部分表单字段进行校验时多次回调
            //         if (validateFieldList.length == 2 && validateFieldList.every((item) => item === "")){
                        let obj = {
                            loginType:1,
                            account: vm.loginform.userName,
                            accountPwd: vm.loginform.userPwd,
                            autoLoginSignal: 3,
                            // ytzhOrgId: '9005',
                            joinState: 4,
                            orgId: vm.loginform.deptId,
                            deviceType: 1,//1:pc， 2：H5  3：小程序
                            visitType: 2,
                            visitUrl: location.href,
                            visitFunc: "",
                        };
                        vm.logining = true;
                        login(obj).then((res) => {
                            vm.logining = false;
                            if(res.code == "200") {    
                                vm.setLoginInfo(res);
                            }
                            if (res.status == "500") {
                                vm.$message({
                                    "message": "登录失败，请联系管理员！",
                                    "type": "error"
                                })
                            }
                        }).catch(err => {
                            vm.logining = false;
                        });
            //         }else {
            //             // console.log("error submit!!")
            //             return false;
            //         }
            //     }
            // });
        },
        //手机号登录
        phoneSubmit(){
            let vm = this,
                validateFieldList = [];
            vm.$refs.loginForm.validateField(['phone', 'smsCode'], async(valid) => {
                if(!valid) {
                    validateFieldList.push(valid);
                    //防止elementUI中validateField对多个部分表单字段进行校验时多次回调
                    if (validateFieldList.length == 2 && validateFieldList.every((item) => item === "")){
                        vm.logining = true;
                        phoneLogin({
                            loginType: 3,
                            orgId: vm.loginform.deptId,
                            phone: vm.loginform.phone,
                            smsCode: vm.loginform.smsCode
                        }).then(res => {
                            vm.logining = false;
                            if(res.status){
                                vm.setLoginInfo(res);
                            }else{                            
                                this.$message({
                                    "message": "登陆失败，请联系管理员！",
                                    "type": "error"
                                })
                            }
                        }).catch(err => {
                                vm.logining = false;
                        });
                    }else {
                        // console.log("error submit!!")
                        return false;
                    }
                }
            });
        },
        //自动登录，第一种情况：根据ip自动登录。第二种情况：学校部署
        AutoLoginByOrg() {
            let vm = this,
            obj = {

                "visitType": 2,
                "visitUrl": location.href,
                "visitFunc": "",
            };
            infoLogin(obj).then((res) => {
                vm.loginform.deptId = res.data.orgId;
                if(vm.loginform.deptId == null || vm.loginform.deptId == '0') {
                    
                } else {
                    vm.autoLoginSwitcher = res.data.autoLoginSwitcher; //autoLoginSwitcher:自动登录开关，1-正常登录(需要账号和密码登录)，2-IP段自动登陆，3-机构无条件自动登录
                    vm.directLoginByOrg();
                }
            }); 
        },
        //一键登录
        directLoginByOrg() {
            let vm = this,
                obj = {
                    autoLoginSwitcher: vm.autoLoginSwitcher,
                    orgId: vm.loginform.deptId,
                    visitType: 2,
                    visitUrl: location.href,
                    visitFunc: '',
                };
            const loading = this.$loading({
                lock: true,
                text: '登录中，请等候...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.4)'
            });
            autoLogin(obj).then(res => {
                if(res.status) {
                    vm.logining = true;
                    vm.setLoginInfo(res);
                    loading.close();
                }
            }).catch(err => {                
                vm.logining = false;
                loading.close();
            }); 
        },
        //微信扫一扫登录
        getWXcode(){
            let vm = this;
            vm.$refs.loginForm.validateField('deptId', (valid) => {
                if (!valid) {                   
                    vm.wx_login = popup('<wx-login :orgid="orgId" @close="close" @ok="submit" />',{
                        option:{
                            title:'微信扫一扫登录',
                            width:'400px',
                            showClose: false, //是否显示关闭按钮
                        },
                        popup:{
                            data(){
                                return{
                                    orgId: vm.loginform.deptId
                                }
                            },
                            components:{
                                wxLogin
                            },
                            methods:{
                                submit(res){
                                    vm.loginType = 3;
                                    vm.setLoginInfo(res);
                                    vm.wx_login.hide();
                                },
                                close(data){
                                    vm.wx_login.hide();
                                }
                            }
                        }
                    })
                    vm.wx_login.show();
                } else { 
                    return false;
                }
            });
        },
    },
};
</script>
 
<style lang="scss">
.Login_wrapper {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 999;
    background: url('../../assets/images/login_bg.jpg') no-repeat top center;
    background-size: 100%;
    .login-box {
        position: absolute;
        width: 400px;
        height: 450px;
        z-index: 200;
        background-color: #ffffff;
        margin-top: -225px;
        left: 60%;
        top: 50%;
        // transform: translate(-50%, -50%);
        z-index: 100;
        padding: 15px 35px 15px 35px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        box-shadow: 0 0 25px #a3b4b6;
    }
    .el-input__inner{
        background-color: #F4F5F8;
        border-color: transparent;
        &:hover{
            border-color: transparent;
        }
    }
    .el-input__prefix{
        font-size:18px;
    }
    .login-title {
        text-align: center;
        margin: 20px auto;
    }
    .login-way{
        text-align: center;
        margin: 10px 0 20px;
        >span{
            font-size:16px;
            font-weight: bold;
            color:#999;
            margin:0 20px;
            position: relative;
            line-height: 28px;
            cursor: pointer;
            &.active{
                color:#1796ff;
                &::before{
                    content: '';
                    position: absolute;
                    left: 0;
                    right: 0;
                    width: 20px;
                    height: 4px;
                    bottom: -8px;
                    margin: auto;
                    background: linear-gradient(270deg, #6580FF 0%, #39AEFF 54%, #45C2FF 100%);
                    border-radius: 3px;
                }
            }
        }
    }
    .input-code{
        width:245px;
    }
    .getcode{
        display: inline-block;
        width: 140px;
        text-align: center;
        margin-left:10px;
        color: #339EFF;
        background: linear-gradient(270deg, #F0F3FF 0%, #E8F5FF 50%, #EDF9FF 100%);
        border-radius:4px;
        border:0 none;
        cursor: pointer;
        &.disabled{
            background: #f0f1f1;
            color:#858585;
            cursor: not-allowed;
        }
    }
    .sendSuccess{
        height:20px;
        line-height:20px;
        color:#666;
        font-size: 12px;
        >i{
            vertical-align: -2px;
            font-size: 16px;
            margin-right:4px;
            color:#19a024;
        }
    }
    .login-btn{
        -webkit-transition: all .3s;
        transition: all .3s;;
        background: linear-gradient(225deg, #6580FF 0%, #39AEFF 54%, #45C2FF 100%);
        border:0 none;
        &:hover{
            background: linear-gradient(225deg, #45C2FF 0%, #39AEFF 54%, #45C2FF 100%);
        }
    }
    .directBtn{
        display: block;
        width: 180px;
        height:180px;
        line-height:180px;
        color:#fff;
        text-align:center;
        font-size:16px;
        margin:0 auto;
        border-radius: 50%;
        cursor: pointer;
        -webkit-transition: all .3s;
        transition: all .3s;;
        background: linear-gradient(225deg, #6580FF 0%, #39AEFF 54%, #45C2FF 100%);
        border:0 none;
        &:hover{
            background: linear-gradient(225deg, #45C2FF 0%, #39AEFF 54%, #45C2FF 100%);
        }
    }
    .remind{
        padding-bottom: 5px;
    }
    .other{
        padding:10px 0;
    }
    .carsi_logo{
        display: inline-block;
        padding-left: 35px;
        margin-right:30px;
        line-height:30px;
        height:30px;
        cursor: pointer;
        color:#333;
        text-decoration: none;
        background: url('../../assets/images/carsi.png') no-repeat 0 center;
        &:hover{
            color:#339EFF;
        }
    }
    .wxLogin{
        display: inline-block;
        padding-left: 30px;
        line-height:30px;
        height:30px;
        cursor: pointer;
        color:#333;
        text-decoration: none;
        background: url('../../assets/images/wxIcon.png') no-repeat 0 center;
        &:hover{
            color:#16a311;
        }
    }
    .direct{
        margin-left: 24px;
        color: #4984ef;
        font-weight:bold;
        cursor: pointer;
        &:hover{
            color: #49adef;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/Login/Login.vue